class LinkedProductSwitcher {
  constructor() {
    this.isLoading = false;
    document.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('popstate', this.handlePopState.bind(this));
  }

  handleClick(event) {
    const link = event.target.closest('[data-linked-product-switch]');
    if (!link) return;

    const sectionId = link.dataset.sectionId;
    const currentSection = document.getElementById(`MainProduct-${sectionId}`);

    if (!sectionId || !currentSection) return;
    if (link.getAttribute('aria-current') === 'page') {
      event.preventDefault();
      return;
    }

    event.preventDefault();

    if (this.isLoading) return;

    this.loadProduct(link.href, sectionId, true);
  }

  handlePopState() {
    const switchLink = document.querySelector('[data-linked-product-switch]');
    const sectionId = switchLink?.dataset.sectionId;

    if (!sectionId) {
      window.location.reload();
      return;
    }

    this.loadProduct(window.location.href, sectionId, false);
  }

  loadProduct(url, sectionId, pushToHistory) {
    const currentSection = document.getElementById(`MainProduct-${sectionId}`);

    if (!currentSection) {
      window.location.href = url;
      return;
    }

    this.isLoading = true;
    currentSection.setAttribute('aria-busy', 'true');
    currentSection.classList.add('is-loading');
    this.hideStickyAtc();

    fetch(this.buildSectionUrl(url, sectionId))
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to load linked product: ${response.status}`);
        return response.text();
      })
      .then((markup) => {
        const html = new DOMParser().parseFromString(markup, 'text/html');
        const nextSection = html.getElementById(`MainProduct-${sectionId}`);

        if (!nextSection) {
          window.location.href = url;
          return;
        }

        this.removeMovedModals(nextSection);
        currentSection.replaceWith(nextSection);
        this.replaceStickyAtc(html);
        if (pushToHistory) window.history.pushState({}, '', url);
      })
      .catch(() => {
        window.location.href = url;
      })
      .finally(() => {
        this.isLoading = false;
        const activeSection = document.getElementById(`MainProduct-${sectionId}`);
        if (activeSection) {
          activeSection.removeAttribute('aria-busy');
          activeSection.classList.remove('is-loading');
        }
      });
  }

  buildSectionUrl(url, sectionId) {
    const sectionUrl = new URL(url, window.location.origin);
    sectionUrl.searchParams.set('section_id', sectionId);
    return sectionUrl.toString();
  }

  hideStickyAtc() {
    const stickyAtc = document.getElementById('sticky-atc');
    if (!stickyAtc) return;

    stickyAtc.classList.remove('sticky-atc--visible');
    stickyAtc.setAttribute('aria-hidden', 'true');
  }

  replaceStickyAtc(html) {
    const currentStickyAtc = document.getElementById('sticky-atc');
    const nextStickyAtc = html.getElementById('sticky-atc');

    if (currentStickyAtc && nextStickyAtc) {
      currentStickyAtc.replaceWith(nextStickyAtc);
    } else if (currentStickyAtc) {
      currentStickyAtc.remove();
    }

    if (typeof window.a4yStickyAtcInit === 'function') {
      window.a4yStickyAtcInit();
    }
  }

  removeMovedModals(nextSection) {
    nextSection.querySelectorAll('product-modal[id], modal-dialog[id]').forEach((nextModal) => {
      const currentModal = document.getElementById(nextModal.id);
      if (!currentModal) return;

      currentModal.remove();
    });

    document.body.classList.remove('overflow-hidden');
  }
}

if (!window.a4yLinkedProductSwitcher) {
  window.a4yLinkedProductSwitcher = new LinkedProductSwitcher();
}
